import { post, get } from '../http'
import { MARKET_URL, LIVE_MEETING_URL, LIVE_GW_URL } from '@/utils/http/baseUrl'
export default {
  // 支付中心
  payCenter: data => post(`/live/PayCenter`, data),
  // 支付中心(红包)
  payRedpacket: data =>
    post(`${MARKET_URL}/api/v1/redpacket/addredpacket`, data),
  // 二维码支付轮询
  checkPayState: code =>
    post(`/liveajax/GetPayState`, { code }, false, {
      contentType: 'application/json;charset=UTF-8'
    }),
  // 支付
  payment: data =>
    post(`/live/payment?t=${data.t}`, data, true, {
      contentType: 'application/json;charset=UTF-8',
      allRes: true
    }),
  // java 支付
  javaPayment: data =>
    post(`${LIVE_GW_URL}/train/v1/cus/pay/payCenter`, data, true, {
      allRes: true
    }),
  // 订单详情
  OrderData: data =>
    post(
      `${LIVE_MEETING_URL}/api/MeetingTicketInfoService/OrderData?orderId=${data.orderId}`,
      data,
      true
    ),
}
// 获取商户号信息
export const getPluginMerchantGray = data => get(`${MARKET_URL}/getPluginMerchantGray`, data)
